// extracted by mini-css-extract-plugin
export default {"cardContainer":"provision-events-asset-view-index-module__cardContainer--q3ma3","tableContainer":"provision-events-asset-view-index-module__tableContainer--U1sPi"};